export default "__VITE_ASSET__B0h9c2DJ__"